// Importing necessary libraries and components
import "bootstrap/dist/css/bootstrap.min.css";
import Driver from "pajoohyar-api-driver";
import React, { useContext } from "react";
import ReactDOM from "react-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import querySearch from "stringquery";
import Cookies from "universal-cookie";
import config from "./config.json";
import ContextComponent from "./Context";
import "./index.css";
import Routes from "./Routes";
import * as serviceWorker from "./serviceWorker";

// Creating a new instance of QueryClient for react-query
const queryClient = new QueryClient();

/**
 * Main component of the application.
 * @returns {JSX.Element} The rendered component.
 */
const Main = () => {
  // Using the useContext hook to access the application context
  const context = useContext(ContextComponent);

  // Parsing the query string from the current URL
  const queryStrings = querySearch(window.location.search);

  // Checking if query strings exist and decoding them
  if (
    Object.keys(queryStrings) !== "" ||
    Object.keys(queryStrings) !== "undefined"
  ) {
    const queryKeys = Object.keys(queryStrings);
    queryKeys.forEach(key => {
      queryStrings[key] = decodeURI(queryStrings[key]);
    });
    context.query_parameters = queryStrings;
  }

  // Initializing the API driver with the imported config
  context.ApiDriver = new Driver(config);

  // Initializing cookies
  context.cookie = new Cookies();
console.log(context.profile);
console.log(context.cookie);
  // Checking for existing authentication cookies
  const access_token = context.cookie.get("pajoohyar_access_token");
  const expires_at = context.cookie.get("pajoohyar_expires_at");
  const profile = context.cookie.get("pajoohyar_profile");
  

  // If authentication cookies exist and are valid, set the context and redirect to the last page
  if (access_token && expires_at && profile && expires_at > Date.now() / 1000) {
    context.ApiDriver.access_token = access_token;
    context.ApiDriver.expires_at = expires_at;
    context.profile = profile;

    const last_page = sessionStorage.getItem("last_page");
    if (last_page) {
      window.location = last_page;
      sessionStorage.removeItem("last_page");
    }
  } else {
    // If authentication cookies do not exist or are invalid, remove them and store the current page
    const current_url = window.location.href;
    if (!current_url.includes("/auth-callback")) {
      sessionStorage.setItem("last_page", window.location.href);
    }

    context.cookie.remove("pajoohyar_access_token");
    context.cookie.remove("pajoohyar_expires_at");
    context.cookie.remove("pajoohyar_profile");
  }

  // Render the Routes component within the QueryClientProvider
  return (
    <QueryClientProvider client={queryClient}>
      <Routes />
    </QueryClientProvider>
  );
};

// Render the Main component into the root element
ReactDOM.render(<Main />, document.getElementById("root"));

// Unregister the service worker
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
